var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEm6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    fill: "none",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F26522",
    d: "M6 6H506V506H6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M212.125 318.42h76.479v-20.807h-52.86v-32.241h48.736v-20.806h-48.736v-30.179h52.86V193.58h-76.479v124.84zm178.637-33.928c0-24.93-1.687-30.366-35.24-38.427-21.556-5.248-21.931-5.623-21.931-19.869 0-10.872 2.812-14.246 18.744-14.246 10.872 0 23.056 1.5 33.366 3.749l2.624-19.869c-12.371-2.812-25.492-4.124-36.364-4.124-31.679 0-41.989 11.247-41.989 33.928 0 26.43 4.124 32.241 34.303 38.989 22.494 4.873 22.869 5.998 22.869 19.869 0 11.997-2.812 15.558-19.87 15.558-12.371 0-23.618-2.249-35.24-5.811l-4.123 18.557c8.247 3.937 24.743 7.498 38.989 7.498 36.927 0 43.862-12.184 43.862-35.802zm43.488-46.487c0-19.119 9.185-22.868 31.303-22.868 3.937 0 12.184.562 17.62 1.687l1.5-19.12c-5.623-1.312-14.621-2.249-21.556-2.249-34.116 0-51.736 10.497-51.736 43.487v45.55c0 21.556 6.373 35.802 38.614 35.802 29.429 0 38.427-14.621 38.427-34.115v-8.997c0-21.557-9.185-30.929-31.866-30.929-8.06 0-15.746 1.125-22.306 3.374v-11.622zm18.744 27.93c8.248 0 12.559 2.811 12.559 11.809v9.185c0 9.56-3.749 13.683-15.558 13.683s-15.745-3.374-15.745-13.683v-17.058c5.248-2.249 11.996-3.936 18.744-3.936z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEm6);
export default __webpack_public_path__ + "static/media/EM6.de533548b377008a63e43699eaf7587f.svg";
export { ForwardRef as ReactComponent };